import type { PresetViewType } from '../api/types';
import type { SavedPresetRecord, Validator } from '../model/types';

export function filterPresetsByViewType<T>(
  presets: SavedPresetRecord[],
  viewType: PresetViewType,
  validator: Validator,
): SavedPresetRecord<T>[] {
  return presets
    .filter((p) => p.viewType === viewType)
    .map((p) => {
      const result = validator(p.preset);
      return result.success ? { ...p, preset: result.data } : null;
    })
    .filter((p): p is SavedPresetRecord<T> => p !== null);
}
